import aa from 'search-insights';
import Cookies from 'js-cookie';

// store algolia parameters in localStorage
export const storeAlgoliaAttributes = () => {
  const queryId = document.querySelector('[data-algolia-query-id]');
  const algoliaIndex = document.querySelector('[data-algolia-index]');
  try {
    const queryIdValue = queryId?.dataset?.algoliaQueryId;
    const algoliaIndexValue = algoliaIndex?.dataset?.algoliaIndex;
    if (queryIdValue) {
      localStorage.setItem('algoliaQueryId', queryIdValue);
      localStorage.setItem('algoliaIndex', algoliaIndexValue);
      return true; // For testing success
    }
    return false; // For testing when ID not available
  } catch (error) {
    console.warn('Failed to save Algolia attributes:', error);
    return false; // For testing failure cases
  }
};

// remove algolia parameters from localStorage
export const removeAlgoliaAttributes = () => {
  let algoliaQueryId = localStorage.getItem('algoliaQueryId');
  let algoliaIndex = localStorage.getItem('algoliaIndex');
  let dataAlgoliaSearchContainer = document.querySelector(".c-pdp-main");
  let dataAlgoliaBtnContainer = document.querySelector(".c-pdp__cta__to-bag button");

  if(algoliaQueryId){
    dataAlgoliaSearchContainer.setAttribute('data-algolia-query-id',algoliaQueryId);
    dataAlgoliaSearchContainer.setAttribute('data-algolia-index', algoliaIndex);
    dataAlgoliaBtnContainer.setAttribute('data-query-id',algoliaQueryId);
    dataAlgoliaBtnContainer.setAttribute('data-index-name', algoliaIndex);
    localStorage.removeItem('algoliaQueryId');
    localStorage.removeItem('algoliaIndex');
  }
};

// Initialize Algolia with configuration
export const algoliaInit = () => {
  let appId = document.querySelector('[data-search-appid]')?.dataset?.searchAppid;
  let apiKey = document.querySelector('[data-search-apikey]')?.dataset?.searchApikey;
  aa('init', {
    appId: appId,
    apiKey: apiKey
  });
};

// Handle common algolia tracking flow
const executeAlgoliaTracking = (trackingFunction) => {
  try {
    algoliaInit();
    trackingFunction();
  } catch (e) {
    console.warn("Error executing Algolia tracking:", e);
  }
};

export const algoliaClickAfterSearch = (product, position) => {
  executeAlgoliaTracking(() => {
    let algoliaQueryId = document.querySelector('[data-algolia-query-id]')?.dataset?.algoliaQueryId;
    let searchIndex = document.querySelector('[data-algolia-index]')?.dataset?.algoliaIndex;
    let authenticatedUserToken = document.querySelector('[data-authenticated-user-token]')?.dataset?.authenticatedUserToken;
    let userToken = document.querySelector('[data-user-token]')?.dataset?.userToken;

    if(algoliaQueryId){
      try {
        // track algolias click
        aa('clickedObjectIDsAfterSearch', {
          userToken: userToken,
          authenticatedUserToken: authenticatedUserToken,
          index: searchIndex,
          eventType: 'click',
          eventName: 'click after search',
          queryID: algoliaQueryId,
          objectIDs: [product.id.toString()],
          positions: [position],
        });
      } catch (e) {
        console.warn("algolia error: ", e);
      }
      console.log("[ALGOLIA Tracking] clickAfterSearch event --> product position:" + (position) + ', productSKU: ' + product.id);
    } else {
      console.warn("Algolia query ID not found");
    }
  });
};

export const algoliaAddToCart = (productCode) => {
  executeAlgoliaTracking(() => {
    let algoliaQueryId = document.querySelector('[data-algolia-query-id]')?.dataset?.algoliaQueryId;
    let authenticatedUserToken = document.querySelector('[data-authenticated-user-token]')?.dataset?.authenticatedUserToken;
    let searchIndex = document.querySelector('[data-algolia-index]')?.dataset?.algoliaIndex;
    let userToken = document.querySelector('[data-user-token]')?.dataset?.userToken;
    let currency = document.querySelector('[data-currency]')?.dataset?.currency;
    let price = document.querySelector('[data-price-algolia]')?.dataset?.priceAlgolia?.replace(/\s+/g, '');
    if(algoliaQueryId){
      try {
        // track algolias click
        aa('addedToCartObjectIDsAfterSearch', {
          userToken: userToken,
          authenticatedUserToken: authenticatedUserToken,
          eventName: 'add to cart',
          index: searchIndex,
          queryID: algoliaQueryId,
          objectIDs: [productCode.toString().substring(0, 15)],
          value: price,
          currency: currency
        });
        console.log("[ALGOLIA Tracking] addToCart event --> productSKU: " + productCode + ', product price: ' + currency + ' ' + price);

      } catch (e) {
        console.warn("algolia error: ", e);
      }
    } else {
      console.log("this product is not from an algolia search result");
    }
  });
};

export const algoliaAddToWishlist = (productCode) => {
  executeAlgoliaTracking(() => {
    let algoliaQueryId = document.querySelector('[data-algolia-query-id]')?.dataset?.algoliaQueryId;
    let authenticatedUserToken = document.querySelector('[data-authenticated-user-token]')?.dataset?.authenticatedUserToken;
    let searchIndex = document.querySelector('[data-algolia-index]')?.dataset?.algoliaIndex;
    let userToken = document.querySelector('[data-user-token]')?.dataset?.userToken;
    let location = '';
    if(document.getElementsByTagName('body')[0]?.classList.contains('t-product')){
      location = 'PDP';
    } else if(document.getElementsByTagName('body')[0]?.classList.contains('t-search') || document.getElementsByTagName('body')[0]?.classList.contains('t-category')){
      location = 'Listing';
    }
    try {
      // track algolias add to wishlist
      aa('convertedObjectIDsAfterSearch', {
        userToken: userToken,
        authenticatedUserToken: authenticatedUserToken,
        index: searchIndex,
        eventName: 'add to wishlist from ' + location,
        queryID: algoliaQueryId,
        objectIDs: [productCode.toString().substring(0, 15)],
      });
      console.log("[ALGOLIA Tracking] addToWishlist event from " + location + " --> productSKU: " + productCode);
    } catch (e) {
      console.warn("algolia error: ", e);
    }
  });
};
